"use strict";
import {
    FALLBACK_COLOR_PATH,
    resolveColorPath
} from "../../../shared/services/themes/colors-charts/color-token";

export class ColorService {
    constructor({ ThemesService } = {}) {
        this.ThemesService = ThemesService;

        this.ColorsChart = ThemesService.getDashboardTheme();
    }

    /**
     * A paleta ativa é lida a cada chamada, não só na construção: quando o
     * `currentDashboardTheme` ainda é "" o `getDashboardTheme` devolve undefined, e um
     * ColorService construído nesse instante pintava o dashboard inteiro sem cor.
     */
    _palettes() {
        const active =
            this.ThemesService.getDashboardTheme() || this.ColorsChart;
        const fallback = this.ThemesService.getDashboardTheme("default");
        return { active: active || fallback, fallback };
    }

    static backgroundColor = (className) => {
        const classes = {
            positive: "bg-positive",
            negative: "bg-negative",
            error: "bg-inconsistency",
            warning: "bg-warning",
            neutro: "bg-neutro",
            inconsistency: "bg-inconsistency",
            "positive-linear": "bg-positive-linear",
            "negative-linear": "bg-negative-linear",
            "error-linear": "bg-error-linear",
            "warning-linear": "bg-warning-linear",
            "neutro-linear": "bg-neutro-linear",
            "basic-linear": "basic-linear",
            "inconsistency-linear": "bg-inconsistency-linear"
        };
        return classes[className];
    };

    static backgroundImage = (backgroundColor) => {
        const images = {
            "bg-positive": "bg-image-cyan",
            "bg-negative": "bg-image-purple",
            "bg-neutro": "bg-image-magenta",
            "bg-error": "bg-image-error",
            "bg-warning": "bg-image-warning"
        };

        return images[backgroundColor];
    };

    /**
     * Identify a color by your pathName in json
     * @public
     * @param {String} path
     * @return {String} Value of path
     */
    colorByPath(pathName) {
        const theme = this.ThemesService.getTheme();
        const { active, fallback } = this._palettes();

        return resolveColorPath(active, fallback, pathName, theme);
    }

    setColorsChart() {
        this.ColorsChart = this.ThemesService.getDashboardTheme();
    }

    getLowerTonality(pathName) {
        if (!pathName) return "";
        const shades = {
            darker: "light",
            dark: "light",
            medium: "light",
            light: "light",
            lighter: "light",
            petroleum: "petroleum"
        };
        const color = pathName.split(".");
        const family = color[0];
        const tonality = color[1];
        // Sem família o retorno não é um token: `colorByPath("light")` não resolve nada.
        if (!family) return FALLBACK_COLOR_PATH;
        return `${family}.${shades[tonality] || "light"}`;
    }
}
